import { EnergyMeter } from "@models/energyMeter";
import { EnergyMonitorHistoryData } from "@dto/energyMonitorHistoryData";
import { EnergyMonitorDistributionData } from "@dto/energyMonitorDistributionData";
import { EnergyMonitorFlowData } from "@dto/energyMonitorFlowData";

export class EnergyMonitorData {
  
  entityName = "EnergyMonitorData";

  utcStartDate: Date = new Date();
  utcEndDate: Date = new Date();

  // powerGridInjectionInWh: number = 0;
  // powerGridExtractionInWh: number = 0;
  // generatedEnergyInWh: number = 0;
  // totalConsumptionInWh: number = 0;
  // directConsumptionInWh: number = 0;
  // autarkyInPercent: number = 0;
  
  totalExportedInWh: number = 0;
  totalDeliveredInWh: number = 0;
  generatedEnergyInWh: number = 0;
  totalConsumptionInWh: number = 0;
  directConsumptionInWh: number = 0;
  autarkyInPercent: number = 0;


  historyData: EnergyMonitorHistoryData[] = [];
  distributionData: EnergyMonitorDistributionData = null;
  flowData: EnergyMonitorFlowData[] = [];

  updateValues(formValue: Partial<EnergyMonitorData>) {
    Object.assign(this, formValue);
  }
}
